module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (263).ffc20e4b.jpg";